import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "../../hooks/useTranslation";
import Button from "../Button";
import { buttonComponent } from "./styles";

interface Props {
  color: string;
}

const ContactUsButton: FC<Props> = ({ color }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const onClick = () => navigate("/contact-us");

  return (
    <Button
      onClick={onClick}
      label={t("headerContactUs")}
      sx={{
        ...buttonComponent,
        color,
      }}
    />
  );
};

export default ContactUsButton;
